import { useCallback } from 'react';
// @mui
import Container from '@mui/material/Container';
// routes
import { paths } from 'src/routes/paths';
// api
import { vuonTrongApiService } from 'src/api/vuontrong-api';
// components
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import { useRouter } from 'src/routes/hook';
import { useSnackbar } from 'src/components/snackbar';
// sections
import VuonTrongNewEditForm from '../vuontrong-new-edit-form';

// ----------------------------------------------------------------------

export default function NewVuonTrongView() {
  const settings = useSettingsContext();
  const router = useRouter();
  const { enqueueSnackbar } = useSnackbar();

  const handleSubmit = useCallback(async (data: any) => {
    try {
      const response = await vuonTrongApiService.createVuonTrong({
        tenVuon: data.tenVuon,
        diaChi: data.diaChi,
        viTri: data.viTri,
        ghiChu: data.ghiChu,
        trangThai: data.trangThai,
      });
      if (response.messCode === 1 || response.messCode === 7) {
        enqueueSnackbar('Tạo vườn trồng thành công!', { variant: 'success' });
        router.push(paths.dashboard.vuontrong.list);
      } else {
        enqueueSnackbar(response.message || 'Tạo vườn trông thất bại', { variant: 'error' });
      }
    } catch (error) { 
      console.error(error);
      enqueueSnackbar('Có lỗi xảy ra khi tạo mới', { variant: 'error' });
    }
  }, [enqueueSnackbar, router]);

  return (
    <Container maxWidth={settings.themeStretch ? false : 'lg'}>
      <CustomBreadcrumbs
        heading="Thêm vườn trồng"
        links={[
          { name: 'Dashboard', href: paths.dashboard.root },
          { name: 'Vườn trồng', href: paths.dashboard.vuontrong.root },
          { name: 'Thêm mới' },
        ]}
        sx={{ mb: { xs: 3, md: 5 } }}
      />

      <VuonTrongNewEditForm current={null} onSubmitForm={handleSubmit} />
    </Container>
  );
}
